import {
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table"
import type { Invoice } from "@tfg/db"
import { useState } from "react"

import { Table } from "~/components/table/Table.tsx"
import { useColumns } from "~/pages/Brand/Invoices/columns.tsx"

const PAGE_SIZE = 50

type Props = {
  orgName: string
  invoices: Invoice[]
}
export const InvoicesTable = ({ invoices, orgName }: Props) => {
  const columns = useColumns(orgName)

  const [sorting, setSorting] = useState<SortingState>([
    { id: "issueDate", desc: true },
  ])

  const table = useReactTable({
    data: invoices,
    columns,
    initialState: {
      pagination: {
        pageSize: PAGE_SIZE,
      },
    },
    state: {
      sorting,
    },
    onSortingChange: setSorting,

    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })

  return <Table table={table} />
}
